import Vue from 'vue'

//import App from './App.vue'
import Main from './Main.vue'

import VueRouter from 'vue-router';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies';

import { globalFormatDate, globalFormatDateShort, globalRusDate, globalRusDateLong, globalRusDateLong2, globalDateHours, globalDateNumeric } from '../public/utils.js';

Vue.use(VueCookies)

Vue.use(VueRouter)

Vue.component('vue-headful', VueHeadful);

Vue.config.productionTip = false

const routes = [
  //{ path: '/main*', component: Main },
  { path: '*', component: Main }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.mixin({
  data: function () {
    return {
      //nodePort: 4001,
      nbsp: '&nbsp;',
      site_title: 'RP Realms (Realms.ru)',
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    getNodePath() {
      //console.log(this.$router.history.current.fullPath); // will output /index.php?act=Members
      return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/api/"
    },
    getVuePath() {
      if (window.location.port === null || window.location.port === '' || window.location.port === 80 || window.location.port === 443)
        return window.location.protocol + "//" + window.location.hostname + "/";
      else
        return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/";
    },
    // decode html in many places
    htmlDecode(input) {
      let doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    // in comments, quotes start with > and need to be wrapped in <font color="#FF0C2D"></font>
    // surprisingly enough, in 2003, this wasn't done by the engine when inserting the comment into the database, but when displaying it
    highlightQuotes(html) {
      // Regular expression to find lines starting with '>' and ending with '<br>'
      const regex = /(^|<br>)(>.*?)(<br>|$)/gs;
      const replacement = '$1<font color="#FF0C2D">$2</font>$3';

      return html.replace(regex, replacement);
    },
    spanSeconds(dateEarly, dateLater) {
      let delta = Math.abs(dateLater - dateEarly) / 1000;
      return delta;
    },
    fixAvatarPath(path) {
      if (!path || path.length == 0 || path.startsWith("http://"))
        return path;
      return this.publicPath + 'avatars/' + path;
    },
    fixRealmsMainPaths(html) {
      // Replace links to realms.ru with realms.su
      html = html.replace(/<a href="http?:\/\/([^"]*?)realms\.ru([^"]*?)"/g, '<a href="http://$1realms.su$2"');

      // Prepend /main/ after realms.su if it's not a subdomain
      html = html.replace(/<a href="http:\/\/realms\.su([^/]*)"/g, '<a href="http://realms.su/main$1"');

      // Replace subdomain forums.realms.su with realms.su
      html = html.replace(/<a href="http:\/\/forums\.realms\.su([^"]*?)"/g, '<a href="http://realms.su$1"');

      // Remove /upload after realms.su
      html = html.replace(/<a href="http:\/\/realms\.su\/upload([^"]*?)"/g, '<a href="http://realms.su$1"');

      // Find all links with /?actions and replace with /main/?actions
      html = html.replace(/<a href="([^"]*?)\/\?actions([^"]*?)"/g, '<a href="$1/main/?actions$2"');

      return html;
    },
    // old code has a bunch of <br>'s in tables, which modern browsers don't handle correctly
    // the browsers push out those brs in front of the table, which creates a bunch of empty space
    // this function removes the brs between <table> and </table>, except inside <td> and </td>
    fixBrs(htmlString) {
      // Match <table>...</table> structures and process them individually
      return htmlString.replace(/<table([^>]*)>([\s\S]*?)<\/table>/gi, function(_, tableParams, tableContent) {
          // Match <td>...</td> structures and replace them with placeholders
          let placeholders = [];
          let processedContent = tableContent.replace(/<td([^>]*)>([\s\S]*?)<\/td>/gi, function(_, tdParams, tdContent) {
              placeholders.push({params: tdParams, content: tdContent});
              return '##td##';
          });

          // Remove all <br> tags
          processedContent = processedContent.replace(/<br>/gi, '');

          // Replace the placeholders with the original <td> content
          let i = 0;
          processedContent = processedContent.replace(/##td##/g, function() {
              let placeholder = placeholders[i++];
              return '<td' + placeholder.params + '>' + placeholder.content + '</td>';
          });

          return '<table' + tableParams + '>' + processedContent + '</table>';
      });
    },
    // changes "hack&#39;n&#39;slash" to "hack'n'slash"
    // but preserves things like <br>
    decodeHtml(html) {
      var textarea = document.createElement("textarea");
      textarea.innerHTML = html;
      return textarea.value;
    },
    // we only have 7 images that survived on webarchive... the rest is lost
    getCircleIcon(circle) {
      if (circle <= 7)
        return circle;
      return 9;
    },
    getDivisionName(num) {
      let myMap = new Map([
        ['1', 'Neverwinter Nights'],
        ['2', 'Neverwinter Nights: Shadows of Undrentide'],
        ['3', 'World of WarCraft'],
        ['4', 'Библиотека'],
        ['5', 'Dungeons & Dragons'],
        ['6', 'Lionheart'],
        ['7', 'Cайт'],
        ['8', 'Neverwinter Nights: Hordes of the Underdark'],
        ['9', 'The Temple of Elemental Evil'],
        ['10', 'Dungeons & Dragons Online'],
        ['11', 'Axistown'],
        ['12', 'Metalheart: Replicants Rampage'],
        ['13', 'The Fall: Last Days of Gaya'],
        ['14', 'Restricted Area'],
        ['15', 'Vampire the Masquerade - Bloodlines'],
        ['16', 'Shadow Vault'],
        ['18', 'Dragon Age'],
        ['19', 'Fallout 3'],
        ['20', 'Мир игровойиндустрии'],
        ['21', 'Space Hack'],
        ['22', 'Neverwinter Nights 2'],
        ['23', 'Солянка из RPG'],
        ['24', 'Информационный лист проекта -=ТехМир=-'],
        ['25', 'ВЛАСТЬ ЗАКОНА'],
        ['26', 'Gothic III'],
        ['28', 'The Witcher'],
      ]);
      num = num.toString();
      if (myMap.has(num)) {
        let value = myMap.get(num);
        return value;
      } else {
        console.log("The key does not exist in the map.");
        console.log(num);
        return '';
      }
    },
    getTitle(num) {
      let titles = ["Арестант", "Житель", "Князь", "Герцог", "Граф", "Барон", "Советник"]
      return titles[num];
    },
    getCircleName(num) {
      let myMap = new Map([
        ['1', 'Обзоры'],
        ['2', 'Статьи'],
        ['3', 'Магия'],
        ['4', 'Предметы'],
        ['5', 'Существа'],
        ['6', 'Обзоры модулей'],
        ['7', 'Статьи о модулях'],
        ['8', 'Информация с официальных форумов Bioware'],
        ['9', 'Остальное'],
        ['10', 'Neverwinter Digest'],
        ['11', 'Прохождение игры'],
        ['12', 'Статьи'],
        ['13', 'Существа'],
        ['14', 'Престиж - классы'],
        ['15', 'Обзоры'],
        ['16', 'Прохождение игры'],
        ['17', 'Тайлсеты'],
        ['18', 'Особенности игры'],
        ['19', 'Расы'],
        ['20', 'Локации'],
        ['21', 'F.A.Q.'],
        ['22', 'Статьи'],
        ['23', 'Существа'],
        ['24', 'Классы'],
        ['25', 'Инф. с официальных форумов'],
        ['26', 'Квесты'],
        ['27', 'Комиксы'],
        ['28', 'Gates to the planes'],
        ['29', 'Рассказы'],
        ['30', 'Путь проклятого'],
        ['31', 'Шепот крови'],
        ['32', 'История одной войны'],
        ['33', 'Легион'],
        ['34', 'Лабиринт праха и пепла'],
        ['35', 'Бегство от безысходности'],
        ['36', 'Наследье ярости'],
        ['37', 'Престиж - классы'],
        ['38', 'Статьи'],
        ['39', 'Классы в 3rd Еdition'],
        ['40', 'Престиж-Классы 3.5е'],
        ['41', 'Особенности игры'],
        ['42', 'Персонаж'],
        ['43', 'Магия'],
        ['44', 'Перки'],
        ['45', 'Трейты'],
        ['46', 'Существа'],
        ['47', 'Предметы'],
        ['48', 'Сюжет игры'],
        ['49', 'Игровой мир'],
        ['50', 'Локации'],
        ['51', 'Официальный FAQ'],
        ['52', 'Информация с официальных форумов'],
        ['53', 'Обзоры/Интервью'],
        ['54', 'Навыки'],
        ['55', 'Информация'],
        ['56', 'Обзоры/Интервью'],
        ['57', 'Статьи'],
        ['58', 'Существа'],
        ['59', 'Престиж - классы'],
        ['60', 'Прохождение игры'],
        ['61', 'Тайлсеты'],
        ['62', 'Предметы'],
        ['63', 'Персонажи'],
        ['64', 'Обзоры/Интервью'],
        ['65', 'Статьи'],
        ['66', 'Существа'],
        ['67', 'Прохождение'],
        ['68', 'Магия'],
        ['69', 'Предметы'],
        ['70', 'Классы'],
        ['71', 'Инф. с официальных форумов'],
        ['72', 'Фиты'],
        ['73', 'Классы'],
        ['74', 'Интервью/Обзоры'],
        ['75', 'Статьи'],
        ['76', 'Статьи'],
        ['77', 'Превью/Обзоры'],
        ['78', 'Обзоры/Интервью'],
        ['79', 'Статьи'],
        ['80', 'Инф. с официальных форумов'],
        ['81', 'Дневники разработчиков'],
        ['82', 'Превью'],
        ['83', 'Ревью'],
        ['84', 'Интервью'],
        ['86', 'Прохождения'],
        ['87', 'F.A.Q.'],
        ['88', 'Разное'],
        ['89', 'Инвентарь'],
        ['90', 'Дневники разработчиков'],
        ['91', 'Превью'],
        ['92', 'Ревью'],
        ['93', 'Интервью'],
        ['95', 'F.A.Q.'],
        ['96', 'Прохождения'],
        ['97', 'Персонажи'],
        ['98', 'Разное'],
        ['99', 'Дневники разработчиков'],
        ['100', 'Превью'],
        ['101', 'Ревью'],
        ['102', 'Интервью'],
        ['104', 'F.A.Q.'],
        ['105', 'Прохождения'],
        ['106', 'Персонажи'],
        ['107', 'Разное'],
        ['108', 'Дневники разработчиков'],
        ['109', 'Превью'],
        ['111', 'Интервью'],
        ['112', 'Ревью'],
        ['116', 'Разное'],
        ['117', 'Прохождения'],
        ['118', 'Инвентарь'],
        ['119', 'Разное'],
        ['132', 'Интервью'],
        ['134', 'Fallout3-Van Buren F.A.Q.'],
        ['137', 'Новости'],
        ['138', 'Fallout Developers Profile'],
        ['139', 'Разное'],
        ['140', 'Интервью'],
        ['141', 'Интервью'],
        ['142', 'Информация с официальных форумов Obsidian'],
        ['151', 'Разное'],
        ['144', 'Trinity'],
        ['146', 'Новости'],
        ['147', 'Nirvana'],
        ['148', 'Обзоры и интервью'],
        ['150', 'О проекте.'],
        ['152', 'F.A.Q.'],
        ['154', 'Обзоры и интервью'],
        ['156', 'Живой мир.'],
        ['157', 'Вооружение и амуниция.'],
        ['158', 'Мир кибернетики.'],
        ['160', 'Game Mechanics'],
        ['161', 'Обзоры и интервью'],
        ['162', 'Расы'],
        ['163', 'Классы'],
        ['164', 'История мира'],
        ['165', 'Газета "Под крылом Дракона"'],
      ]);
      num = num.toString();
      if (myMap.has(num)) {
        let value = myMap.get(num);
        return value;
      } else {
        console.log("The key does not exist in the map.");
        console.log(num);
        return '';
      }
    },
  },
  filters: {
    formatDate: function(value) {
      return globalRusDate(value);
    },
    formatDateShort: function(value) {
      return globalFormatDateShort(value);
    },
    formatRusDateLong: function(value) {
      return globalRusDateLong(value);
    },
    formatInt: function(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // formats 4123 to 4.123
    },
    formatRusDateLong2: function(value) {
      return globalRusDateLong2(value);
    },
    formatDateHours: function(value) {
      return globalDateHours(value);
    },
    formatDateNumeric: function(value) {
      return globalDateNumeric(value);
    },
  }
})

new Vue({
  router
  //render: h => h(Main),
}).$mount('#app')
